import ContactForm from './ContactForm'

function About() {
    return (
        <>
            <h1 id="About">About</h1>
            <p>
                I'm a passionate software engineer looking to build cool projects that help people.
                While my background is in the biological sciences (entomology), I have found my innate curiosity,
                creativity, and problem-solving skills transitioned well into the world of coding.
                I began my coding journey in August 2019, and I haven't stopped since.
            </p>
            <p>
                If your company is looking for an enthusiatic teamplayer with a passion for learning all things coding,
                please reach out to me using the form below!
            </p>
            <h2>Contact Me!</h2>
            <ContactForm />
        </>
    )
}

export default About;